import { cva } from '@/styled-system/css';

export const datePickerContentRecipe = cva({
  base: {
    display: 'flex',
    borderRadius: 'obj.soft',
    flexDirection: 'column',
    backgroundColor: 'DatePicker.Content.bg',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'hidden',
    paddingBlock: 'default',
    paddingInline: 'default',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: '{easings.ease}',
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
    modal: {
      true: {
        blockSize: 'auto',
        transitionDuration: {
          _motionReduce: '0s',
          _motionSafe: '{durations.200}',
        },
        transitionTimingFunction: '{easings.ease-out}',
      },
      false: {},
    },
  },
});

export const datePickerContentPositionerRecipe = cva({
  variants: {
    modal: {
      true: {
        zIndex: 2,
      },
      false: {
        zIndex: 'datePicker',
      },
    },
  },
});
